<mat-card class="card-style-full px-6 py-6 pt-0">
  <mat-card-header class="flex justify-between items-center gap-2">
    <div class="flex-1">
      <div class="text-xl text-gray-700 font-bold">Financeiro</div>
    </div>

    <button
      mat-flat-button
      style="
        width: 170px;
        height: 40px;
        padding: 16px;
        background-color: #ea6218;
        color: white;
        border-radius: 12px;
      "
      (click)="close()"
    >
      <span style="margin-right: 8px">&lt;</span>VOLTAR
    </button>
  </mat-card-header>

  <div class="my-3"></div>
  <div>
    <mat-accordion multi>
      <mat-expansion-panel expanded>
        <div>
          <div [formGroup]="form" class="mt-4 container mx-auto">
            <div class="flex justify-between items-end mt-3 -mx-2">
              <!-- Container geral -->
              <div class="px-2 w-full max-w-md">
                <!-- Label fica fora do flex que contém select + botão -->

                <!-- Flex para select + botão -->
                <div class="flex gap-4 items-end">
                  <!-- Select com largura fixa -->
                  <mat-form-field
                    appearance="outline"
                    style="min-width: 350px; flex-grow: 1"
                  >
                    <mat-label>Selecione o Status</mat-label>
                    <mat-select
                      id="statusOperationSelect"
                      formControlName="statusOperation"
                      placeholder="Escolha uma opção"
                    >
                      <mat-option value="">
                        <em>Nenhum selecionado</em>
                      </mat-option>

                      <mat-option
                        *ngFor="let type of ListOperationStatus"
                        [value]="type.id"
                      >
                        <div class="flex flex-col leading-tight">
                          <span class="text-xs text-gray-500">{{
                            type.codigo
                          }}</span>
                          <span class="text-sm font-medium text-gray-800">{{
                            type.descricao
                          }}</span>
                        </div>
                      </mat-option>
                    </mat-select>
                  </mat-form-field>

                  <!--  <button
                    mat-flat-button
                    style="
                      height: 56px;
                      width: 170px;
                      padding: 24px;
                      margin-left: 25px;
                      background-color: #ea6218;
                      color: white;
                      font-weight: 600;
                      border-radius: 12px;
                      box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
                      flex-shrink: 0;
                      flex-basis: 170px;
                    "
                  >
                    PESQUISAR
                  </button> -->
                </div>
              </div>

              <!--    </div>-->

              <!--    <div class="flex justify-between items-center mt-3 -mx-2">-->
              <!--  <mat-form-field class="input-tg w-3/12 px-2" appearance="outline">
                <mat-label>Nome evento</mat-label>
                <input matInput formControlName="eventName" />
              </mat-form-field>

              <mat-form-field class="input-tg w-3/12 px-2" appearance="outline">
                <mat-label>Data inicio</mat-label>
                <input
                  matInput
                  [matDatepicker]="dateStart"
                  (focus)="openDatepicker('dateStart')"
                  formControlName="dateStart"
                  readonly
                />
                <mat-datepicker-toggle
                  matIconSuffix
                  [for]="dateStart"
                ></mat-datepicker-toggle>
                <mat-datepicker #dateStart></mat-datepicker>
              </mat-form-field>

              <mat-form-field class="input-tg w-3/12 px-2" appearance="outline">
                <mat-label>Data fim</mat-label>
                <input
                  matInput
                  [matDatepicker]="dateEnd"
                  (focus)="openDatepicker('dateEnd')"
                  formControlName="dateEnd"
                  readonly
                />
                <mat-datepicker-toggle
                  matIconSuffix
                  [for]="dateEnd"
                ></mat-datepicker-toggle>
                <mat-datepicker #dateEnd></mat-datepicker>
              </mat-form-field> -->

              <!--      <div class="w-4/12 px-2">-->
              <!--        <div class="box-form">-->
              <!--          <h4>Inicio evento</h4>-->
              <!--          <div class="input-box flex justify-between items-center w-full">-->
              <!--            <mat-form-field-->
              <!--              class="input-tg w-9/12 px-2 no-message-new"-->
              <!--              appearance="outline"-->
              <!--            >-->
              <!--              <mat-label>Data</mat-label>-->
              <!--              <input-->
              <!--                matInput-->
              <!--                [matDatepicker]="dateStart"-->
              <!--                (focus)="openDatepicker('dateStart')"-->
              <!--                formControlName="dateStart"-->
              <!--                readonly-->
              <!--              />-->
              <!--              <mat-datepicker-toggle-->
              <!--                matIconSuffix-->
              <!--                [for]="dateStart"-->
              <!--              ></mat-datepicker-toggle>-->
              <!--              <mat-datepicker #dateStart></mat-datepicker>-->
              <!--            </mat-form-field>-->

              <!--            <mat-form-field-->
              <!--              class="input-tg w-3/12 px-2 no-message-new"-->
              <!--              appearance="outline"-->
              <!--            >-->
              <!--              <mat-label>Hora (24h)</mat-label>-->
              <!--              <input matInput type="time" formControlName="timeStart" />-->
              <!--            </mat-form-field>-->
              <!--          </div>-->
              <!--        </div>-->
              <!--      </div>-->
              <!--      <div class="w-4/12 px-2">-->
              <!--        <div class="box-form">-->
              <!--          <h4>Final evento</h4>-->
              <!--          <div class="input-box flex justify-between items-center w-full">-->
              <!--            <mat-form-field-->
              <!--              class="input-tg w-9/12 px-2 no-message-new"-->
              <!--              appearance="outline"-->
              <!--            >-->
              <!--              <mat-label>Data</mat-label>-->
              <!--              <input-->
              <!--                matInput-->
              <!--                [matDatepicker]="dateEnd"-->
              <!--                (focus)="openDatepicker('dateEnd')"-->
              <!--                formControlName="dateEnd"-->
              <!--                readonly-->
              <!--              />-->
              <!--              <mat-datepicker-toggle-->
              <!--                matIconSuffix-->
              <!--                [for]="dateEnd"-->
              <!--              ></mat-datepicker-toggle>-->
              <!--              <mat-datepicker #dateEnd></mat-datepicker>-->
              <!--            </mat-form-field>-->
              <!--            <mat-form-field-->
              <!--              class="input-tg w-3/12 px-2 no-message-new"-->
              <!--              appearance="outline"-->
              <!--            >-->
              <!--              <mat-label>Hora (24h)</mat-label>-->
              <!--              <input matInput type="time" formControlName="timeEnd" />-->
              <!--            </mat-form-field>-->
              <!--          </div>-->
              <!--        </div>-->
              <!--      </div>-->
            </div>

            <div class="flex justify-between items-center mt-3 -mx-2">
              <mat-form-field class="input-tg w-8/12 px-2" appearance="outline">
                <mat-label>Cliente</mat-label>
                <input matInput formControlName="client" readonly />
                @if (this.form.get('client')!.enabled) {
                  <button mat-icon-button matSuffix (click)="addClient()">
                    <mat-icon>add</mat-icon>
                  </button>
                }
              </mat-form-field>
              <mat-form-field class="input-tg w-8/12 px-2" appearance="outline">
                <mat-label>Subcliente</mat-label>
                <input matInput formControlName="subClient" readonly />
                @if (this.form.get('subClient')!.enabled) {
                  <button mat-icon-button matSuffix (click)="addSubClient()">
                    <mat-icon>add</mat-icon>
                  </button>
                }
              </mat-form-field>
            </div>

            <div class="flex justify-between items-center mt-3 -mx-2">
              <mat-form-field class="input-tg w-8/12 px-2" appearance="outline">
                <mat-label>Código TG</mat-label>
                <input matInput formControlName="tgCode" />
                @if (this.form.get('client')!.enabled) {}
              </mat-form-field>

              <mat-form-field class="input-tg w-3/12 px-2" appearance="outline">
                <mat-label>Data inicio</mat-label>
                <input
                  matInput
                  [matDatepicker]="dateStart"
                  (focus)="openDatepicker('dateStart')"
                  formControlName="dateStart"
                  readonly
                />
                <mat-datepicker-toggle
                  matIconSuffix
                  [for]="dateStart"
                ></mat-datepicker-toggle>
                <mat-datepicker #dateStart></mat-datepicker>
              </mat-form-field>

              <mat-form-field class="input-tg w-3/12 px-2" appearance="outline">
                <mat-label>Data fim</mat-label>
                <input
                  matInput
                  [matDatepicker]="dateEnd"
                  (focus)="openDatepicker('dateEnd')"
                  formControlName="dateEnd"
                  readonly
                />
                <mat-datepicker-toggle
                  matIconSuffix
                  [for]="dateEnd"
                ></mat-datepicker-toggle>
                <mat-datepicker #dateEnd></mat-datepicker>
              </mat-form-field>

              <!--      <mat-form-field class="input-tg w-3/12 px-2" appearance="outline">-->
              <!--        <mat-label>Taxa Serviço</mat-label>-->
              <!--        @if (form.get('serviceFee')!.value != '') {-->
              <!--          <span matTextSuffix>%&nbsp;</span>-->
              <!--        }-->
              <!--        <input-->
              <!--          matInput-->
              <!--          formControlName="serviceFee"-->
              <!--          currencyInput-->
              <!--          (blur)="updateGrandTotal()"-->
              <!--        />-->
              <!--      </mat-form-field>-->
            </div>

            <!--  <div class="w-full my-4">
              <div class="box-form">
                <h4 class="bg-gray">Solicitante</h4>
                <div class="input-box flex justify-between items-center w-full">
                  <mat-form-field
                    class="input-tg w-4/12 px-2 no-message-new"
                    appearance="outline"
                  >
                    <mat-label>Nome</mat-label>
                    <input matInput formControlName="requesterName" />
                  </mat-form-field>

                  <mat-form-field
                    class="input-tg w-4/12 px-2 no-message-new"
                    appearance="outline"
                  >
                    <mat-label>Email</mat-label>
                    <input matInput formControlName="requesterEmail" />
                  </mat-form-field>

                  <mat-form-field
                    class="input-tg w-4/12 px-2 no-message-new"
                    appearance="outline"
                  >
                    <mat-label>Telefone</mat-label>
                    <input
                      matInput
                      formControlName="requesterPhone"
                      [mask]="'(99) 99999-9999'"
                    />
                  </mat-form-field>
                </div>
              </div>
            </div> -->

            <div class="flex justify-end items-center mt-4 mb-6 -mx-2">
              <!--              <div class="w-9/12 px-2">-->
              <!--                <div class="box-form">-->
              <!--                  <h4>Comissão | Divisor | Taxa</h4>-->
              <!--                  <div-->
              <!--                    class="input-box flex justify-between items-center w-full"-->
              <!--                  >-->
              <!--                    <mat-form-field-->
              <!--                      class="input-tg w-3/12 px-2 no-message-new"-->
              <!--                      appearance="outline"-->
              <!--                    >-->
              <!--                      <mat-label>Tipo</mat-label>-->
              <!--                      <mat-select-->
              <!--                        formControlName="typeCommission"-->
              <!--                        (selectionChange)="onSelectionChangeType($event)"-->
              <!--                      >-->
              <!--                        @for (type of ListCommission; track type) {-->
              <!--                          <mat-option-->
              <!--                            [value]="type.value"-->
              <!--                            [disabled]="type.disabled"-->
              <!--                          >-->
              <!--                            {{ type.description }}-->
              <!--                          </mat-option>-->
              <!--                        }-->
              <!--                      </mat-select>-->
              <!--                    </mat-form-field>-->
              <!--                    <mat-form-field-->
              <!--                      class="input-tg w-3/12 px-2 no-message-new"-->
              <!--                      appearance="outline"-->
              <!--                    >-->
              <!--                      <mat-label>Comissão</mat-label>-->
              <!--                      @if (form.get('commission')!.value != '') {-->
              <!--                        <span matTextSuffix>%&nbsp;</span>-->
              <!--                      }-->
              <!--                      <input-->
              <!--                        matInput-->
              <!--                        formControlName="commission"-->
              <!--                        decimalInput-->
              <!--                      />-->
              <!--                    </mat-form-field>-->
              <!--                    <mat-form-field-->
              <!--                      class="input-tg w-3/12 px-2 no-message-new"-->
              <!--                      appearance="outline"-->
              <!--                    >-->
              <!--                      <mat-label>Divisor</mat-label>-->
              <!--                      <input matInput formControlName="divider" decimalInput />-->
              <!--                    </mat-form-field>-->
              <!--                    <mat-form-field-->
              <!--                      class="input-tg w-3/12 px-2 no-message-new"-->
              <!--                      appearance="outline"-->
              <!--                    >-->
              <!--                      <mat-label>Taxa</mat-label>-->
              <!--                      @if (form.get('tax')!.value != '') {-->
              <!--                        <span matTextSuffix>%&nbsp;</span>-->
              <!--                      }-->
              <!--                      <input matInput formControlName="tax" currencyInput />-->
              <!--                    </mat-form-field>-->
              <!--                  </div>-->
              <!--                </div>-->
              <!--              </div>-->
              <!--  <mat-form-field
                class="input-tg w-3/12 px-2 no-message-new"
                appearance="outline"
              >
                <mat-label>Total Geral</mat-label>
                @if (form.get('grandTotal')!.value != '') {
                  <span matTextPrefix>R$&nbsp;</span>
                }
                <input matInput formControlName="grandTotal" currencyInput />
              </mat-form-field> -->
            </div>
          </div>
        </div>
      </mat-expansion-panel>
    </mat-accordion>
  </div>
</mat-card>
